import "./App.css";
import AppRouter from "./services/router";

function App() {
  return <AppRouter />;
}

export default App;
